import { Checks, Copy, WarningCircle, X } from "@phosphor-icons/react";
import React from "react";
import dayjs from "dayjs"; // Use for date/time formatting
 
const GetWifiModel = ({requestData,setRequestType,setOpenRequestModal,setRequestData}) => {
  
    // Format the date and time
 

    // Close Modal
    const closeModal=()=>{
        try{
            setOpenRequestModal(false);
            setRequestType("");
            setRequestData(null);
            
        }catch(error){
            console.log(error);
        }
    }

    // console.log("Data of Cab : ",requestData);

    return (
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
           
            <div
                className="popup-content bg-white p-6 rounded-lg text-sm flex flex-col gap-2 w-[80%] md:w-[70%] lg:w-[50%]">
                
                {/*  Request Header */}
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-semibold">Get Wifi Request</h2>
                    <button
                        className="hover:bg-[#F2F7FF] p-1.5 border-[1.5px] rounded-md"
                        type="button"
                        onClick={()=>closeModal()}
                    >
                        <X weight="bold" size={18} />
                    </button>
                </div>

                <div className="flex flex-col gap-4">

                    {/* Room Details */}
                    <div className="flex items-center justify-between"> 

                        {requestData.service_room && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">Service Room</p>
                                <p>{requestData?.service_room || ""}</p>
                            </div>
                        }
            
                        {requestData.number_of_devices && 
                            <div className="w-1/3">
                                <p className="text-[#8C9199] mb-2">
                                    Number of Devices
                                </p>
                                <p>{requestData?.number_of_devices || ""}</p>
                            </div>
                        }

                    </div>

                    
                    {/* additional_comments */}
                    {requestData?.additional_comments && 
                        <div>
                            <p className="text-[#8C9199] mb-1">Additional Comments</p>
                            <textarea
                                value={requestData?.additional_comments || ""}
                                rows={4}
                                className="w-full border-[1.5px] rounded-md p-2"
                                placeholder="Please leave your remarks here"
                                disabled
                            ></textarea>
                        </div>
                    }
                 
                    {/* Remarks */}
                    {requestData?.remarks && 
                        <div>
                            <p className="text-[#8C9199] mb-1">Remarks</p>
                            <textarea
                                value={requestData?.remarks || ""}
                                rows={4}
                                className="w-full border-[1.5px] rounded-md p-2"
                                placeholder="Please leave your remarks here"
                                disabled
                            ></textarea>
                        </div>
                    }

                </div>

                {/* Wifis */}
                <div className="flex flex-wrap gap-2 ">
                    {requestData?.wifi_name_passwords &&
                        requestData?.wifi_name_passwords.map((wifi, index) => (
                            <>
                                <div key={index} className="border-[1.5px] rounded-md p-3 w-full md:w-[48%] lg:w-[30%]">
                                    <p className="text-[#8C9199] mb-1">Wifi {index + 1}</p>
                                    <p><span className="font-semibold">Name:</span> {wifi.wifi_name || ""}</p>
                                    <p><span className="font-semibold">Password:</span> {wifi.wifi_password || ""}</p>
                                </div>
                            </>
                        ))
                    }
                </div>

            </div>
   

        </div>
    );
};

export default GetWifiModel;
